module.exports = __webpack_public_path__ + "img/Vue2.bbd6c024.png";